import { render, staticRenderFns } from "./TextColorEditable.vue?vue&type=template&id=4b7d4446&scoped=true&lang=html&"
import script from "./TextColorEditable.vue?vue&type=script&lang=js&"
export * from "./TextColorEditable.vue?vue&type=script&lang=js&"
import style0 from "./TextColorEditable.vue?vue&type=style&index=0&id=4b7d4446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d4446",
  null
  
)

export default component.exports